<template>
    <div class="fd-com-page">
        <ac-title-bar
            title="复议申请"
            @back="back">
            <div>(<span v-text="total"></span>)</div>
        </ac-title-bar>
        <ul class="fd-com-tab">
            <li
                class="fd-item"
                :class="{'fd-active': currentTabNav === item.id}"
                v-for="(item, index) in tabNavList"
                :key="index"
                @click="changeTabNav(item)">
                {{ item.name }}
            </li>
        </ul>
        <div class="fd-com-search">
            <van-search
                placeholder="输入申请编号/申请人/申请法院"
                v-model="keyWord"
                @search="onSearch">
            </van-search>
            <van-icon class="fd-com-btn-refresh" name="replay" @click="refresh"/>
        </div>
        <div class="fd-com-nodata" v-if="total === 0">
            暂无数据
        </div>
        <van-list
            class="fd-com-card-list"
            v-else
            v-model="loading"
            :finished="finished"
            :finished-text="loading ? '加载中...' : '没有更多了'"
            @load="loadData">
            <div
                class="fd-com-card"
                v-for="(item, index) of list"
                :key="index"
                @click="goDetail(item.cId, item.cFyzt)">
                <h3 class="fd-com-card-title">
                    {{ item.nFycs }}
                    <van-tag v-if="item.cFyzt === '复议待提交'" type="warning" :plain="false">
                        {{ item.cFyzt }}
                    </van-tag>
                    <van-tag v-else-if="item.cFyzt === '已复议'" type="success" :plain="false">
                        {{ item.cFyzt }}
                    </van-tag>
                    <van-tag v-else-if="item.cFyzt === '审核不通过'" type="danger" :plain="false">
                        {{ item.cFyzt }}
                    </van-tag>
                    <van-tag v-else-if="item.cFyzt === '已取消'" :plain="false">
                        {{ item.cFyzt }}
                    </van-tag>
                    <van-tag v-else type="info" :plain="false">
                        {{ item.cFyzt }}
                    </van-tag>
                </h3>
                <ul class="fd-com-card-info">
                    <li>
                        <span class="fd-com-label">复议编号</span>
                        <span class="fd-com-content">{{ item.cSqbh }}</span>
                    </li>
                    <li>
                        <span class="fd-com-label">申请人</span>
                        <span class="fd-com-content">{{ item.cSqrxm }}</span>
                    </li>
                    <li>
                        <span class="fd-com-label">案号</span>
                        <span class="fd-com-content">{{ item.cBqah }}</span>
                    </li>
                    <li>
                        <span class="fd-com-label">申请法院</span>
                        <span class="fd-com-content">{{ item.cSqdyfymc }}</span>
                    </li>
                </ul>
                <div
                    class="fd-com-card-bottom"
                    v-if="item.btnList.includes(btnType.BJ_BUTTON) || item.btnList.includes(btnType.SC_BUTTON) || item.btnList.includes(btnType.CXSQFY_BUTTON)">
                    <van-button
                        v-if="item.btnList.includes(btnType.BJ_BUTTON)"
                        class="fd-com-card-btn"
                        @click="onBtnClick(btnType.BJ_BUTTON, item.cId)">
                        编辑
                    </van-button>
                    <van-button
                        v-if="item.btnList.includes(btnType.SC_BUTTON)"
                        class="fd-com-card-btn"
                        @click="onBtnClick(btnType.SC_BUTTON, item.cId)">
                        删除
                    </van-button>
                    <van-button
                        v-if="item.btnList.includes(btnType.CXSQFY_BUTTON)"
                        class="fd-com-card-btn"
                        @click="onBtnClick(btnType.CXSQFY_BUTTON, item.cId)">
                        重新申请
                    </van-button>
                </div>
            </div>
        </van-list>
<!--        <div class="fd-com-btn-container">-->
<!--            <van-button-->
<!--                type="info"-->
<!--                round-->
<!--                @click="applyReconsider">-->
<!--                申请复议-->
<!--            </van-button>-->
<!--        </div>-->
    </div>
</template>

<script>
// 标题栏
import acTitleBar from "@/components/app/title-bar/index.vue";
import { Dialog } from "vant";
import { typeFysx, typeFyzt } from "@/filters/index";
import { btnType } from "@/utils/consts";
export default {
  data() {
    return {
      keyWord: "", // 搜索关键字
      total: 0, // 保全总数
      list: [],
      loading: false, // 列表加载状态
      finished: false, // 是否列表全部加载完成
      page: 0, // 页码
      size: 10, // 每页尺寸, 固定不会改变
      btnType: btnType,
      smallPro: "",
        // 嵌入在线服务新增——顶部tab导航数据
        tabNavList: [
            {id: 'bqsq', name: '保全申请'},
            {id: 'fysq', name: '复议申请'},
            {id: 'jbsq', name: '解保申请'},
            {id: 'xbsq', name: '续保申请'}
        ],
        // 嵌入在线服务新增——当前tab导航标识
        currentTabNav: 'fysq'
    };
  },
  components: {
    acTitleBar,
  },
  methods: {

    /**
     * @function
     * @description 嵌入在线保全新增交互——点击申请复议
     * @return {undefined} 无返回值
     */
    applyReconsider() {
        this.$router.push({
            path: '/reconsiderBasic'
        });
    },

    /**
     * @function
     * @description 点击顶部tab导航
     * @param {*} item 当前点击对象数据
     * @return {undefined} 无返回值
     */
    changeTabNav(item) {
        this.currentTabNav = item.id;
        switch (this.currentTabNav) {
            // 保全申请
            case 'bqsq':
                this.$router.push("/home/myPreservation");
                break;
            // 复议申请
            case 'fysq':
                this.$router.push("/home/myReconsider");
                break;
            // 解保申请
            case 'jbsq':
                this.$router.push("/home/myRelievPreservation");
                break;
            // 续保申请
            case 'xbsq':
                this.$router.push("/home/myContinuationPreservation");
                break;
            default:
                break;
        }
    },

    // 返回事件
    back() {
      // 返回到我的申请里面
      this.$router.push("/home/myApply");
    },
    //刷新页面
    refresh() {
      window.location.reload();
    },
    //跳转详情
    goDetail(Id, cFyzt) {
      if (cFyzt == "复议待提交") {
        return;
      }
      this.$router.push({
        path: "/reconsiderDetail",
        query: {
          // 复议id
          fyid: Id,
        },
      });
    },
    loadData() {
      this.loading = true;
      this.$axios
        .get(
          "ssbq/api/fy/xcx/yzwfysqs?page=" +
            ++this.page +
            "&rows=" +
            this.size +
            "&searchValue=" +
            encodeURI(this.keyWord)
        )
        .then((res) => {
          let data = res.data;
          this.total = data.total;
          let listData = data.list;
          for (let db of listData) {
            let temp = {
              cId: db.cId,
              nFycs: typeFysx(db.nFysx), // 复议事项
              cFyzt: typeFyzt(db.cFyzt), // 保全状态
              cBqah: db.cBqah,
              cSqrxm: db.cSqrxm, // 申请人姓名
              cDsrxm: db.cDsrxm, // 当事人姓名
              cSqdyfymc: db.cSqfymc, // 申请法院名称
              nSqbqje: db.nSqbqje, // 申请保全金额
              nJfje: db.nJfje, // 缴费金额
              nSqbqdcsfy: db.nSqbqdcsfy, // 建议保全费
              cSqbh: db.cSqbh,
              btnList: [], // 要展示的按钮
            };
            if (db.showBtn) {
              temp.btnList = db.showBtn.split(",").map(Number);
            }
            this.list.push(temp);
          }
          if (this.page * this.size >= this.total) {
            // 数据全部加载完成, 接口返回的totalPage为空, 采用另一种方法判断
            this.finished = true;
          }
          // 加载状态结束
          this.loading = false;
        });
    },
    onSearch: function () {
      // 搜索时重置页数和数据
      this.page = 0;
      this.list = [];
      // 需要重置finished值
      this.finished = false;
      // 加载数据
      this.loadData();
    },
    onBtnClick: function (type, id) {
      if (type === this.btnType.BJ_BUTTON) {
        // 编辑
        this.$router.push({
          path: "/applyReconsider",
          query: {
            // 复议id
            id: id,
          },
        });
        return;
      }
      if (type === this.btnType.SC_BUTTON) {
        // 删除
        Dialog.confirm({
          title: "提示",
          message: "确认删除吗？删除后不可恢复",
          confirmButtonColor: "#ffffff",
          cancelButtonColor: "#ffffff",
        })
          .then(() => {
            this.$axios
              .delete("ssbq/api/fy/fysq/delfy?id=" + id)
              .then((res) => {
                if (res.code === 204) {
                  this.$notify({
                    message: "删除成功",
                    type: "success",
                  });
                  this.page = 0;
                  this.list = [];
                  this.loadData();
                }
              });
          })
          .catch(() => {});
        return;
      }
      // 重新申请复议
      if (type === btnType.CXSQFY_BUTTON) {
        this.$axios.get("ssbq/api/fy/cxsqfy?fyid=" + id).then((res) => {
          if (res.code == 200) {
            // 跳转到复议申请页面
            this.$router.push(`/applyReconsider?id=${id}`);
          } else {
            this.$notify(res.message);
            return;
          }
        });
        return;
      }
    },
  },
  created() {
    this.loadData();
  }
};
</script>
